import type { TripQuoteDetail } from "./bookings-api";

type OfferEntry = {
  carId: number;
  dateFrom: string;
  dateTo: string;
  rentalType: string;
  pickupTime?: string;
  dropoffTime?: string;
  deliveryDistance?: number;
  airportCode?: string;
  deliveryAddress?: string;
  hours?: number;
};

const text = (value: string | null | undefined) => (value ?? "").trim();
const date = (value: string) => value.split("T")[0];
const time = (value: string | null | undefined) => value ? value.slice(11, 16) : "";
const number = (value: number | null | undefined) => value == null ? null : Number(value);

/** A faithful offer entry is not an edit. Coordinates deliberately stay out
 * of browser drafts and are recovered from the authenticated offer read. */
export function hostOfferEntryMatches(offer: TripQuoteDetail, entry: OfferEntry): boolean {
  const delivery = (entry.deliveryDistance ?? 0) > 0 || !!text(entry.airportCode) || !!text(entry.deliveryAddress);
  return offer.carId === entry.carId &&
    date(offer.dateFrom) === date(entry.dateFrom) &&
    date(offer.dateTo) === date(entry.dateTo) &&
    offer.rentalType === entry.rentalType &&
    time(offer.pickupAt) === text(entry.pickupTime) &&
    time(offer.dropoffAt) === text(entry.dropoffTime) &&
    !!offer.isDelivery === delivery &&
    number(offer.deliveryDistance) === number(entry.deliveryDistance) &&
    text(offer.airportCode).toUpperCase() === text(entry.airportCode).toUpperCase() &&
    (!delivery || text(offer.deliveryAddress) === text(entry.deliveryAddress)) &&
    (offer.rentalType !== "chauffeured" || number(offer.hours) === number(entry.hours));
}
